import { render, staticRenderFns } from "./VlanTaggedSelectSelection.vue?vue&type=template&id=396a1fda&scoped=true&"
import script from "./VlanTaggedSelectSelection.vue?vue&type=script&lang=ts&"
export * from "./VlanTaggedSelectSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a1fda",
  null
  
)

export default component.exports